import Record from '../Record'

export default class ErrorLogEntry extends Record {

	constructor (data) {
		super(data)
		return this._proxy
	}

	static async fetch (id = null) {
		if (id == null) {
			// Create record
			throw new Error('Nem adott meg hibabejegyzés azonosítót')
		} else {
			// Load
			let data = await Anvil.REST.get(`/c_order/error_log/${id}`)
			return new ErrorLogEntry(data)
		}
	}
}
